import * as React from 'react'
import { connect } from 'react-redux'
import { Body } from '../components/Body/Body'
import { AppState } from '../store'
import { OnboardingController, SessionController, UserController } from '../controllers'
import Notification from '../utilities/Notification'
import { AnyAction, Dispatch } from 'redux'
import { setCurrentUser } from '../store/authentication/actions'
import { RouteComponentProps } from 'react-router';
import ERoute from '../ERoute';
import ScrollToTopOnMount from '../components/Effects/ScrollToTopOnMount'
import { Helmet } from 'react-helmet'
import { WithTranslation, withTranslation } from 'react-i18next'
import { CurrentUser } from '../types'
import Images from '../images'
import { MailCheck } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface IStateToProps {
  currentUser: CurrentUser
}

interface IDispatchToProps {
  setCurrentUser: typeof setCurrentUser
}

type IProps = IStateToProps & IDispatchToProps & RouteComponentProps<any> & WithTranslation

class ConfirmEmail extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props)

    this.onVerifyConfirmedClick = this.onVerifyConfirmedClick.bind(this)
    this.onResendEmailClick = this.onResendEmailClick.bind(this)
    this.navigateToOnboarding = this.navigateToOnboarding.bind(this)
    this.onLogoutClick = this.onLogoutClick.bind(this)
  }

  navigateToOnboarding() {
    const { history } = this.props
    history.push(ERoute.PATH_DASHBOARD)
  }

  componentWillMount() {
    const { currentUser } = this.props
    if (currentUser.email_confirmed_at) {
      this.navigateToOnboarding()
    }
  }

  onVerifyConfirmedClick(e) {
    e.preventDefault()

    const { setCurrentUser, t } = this.props

    UserController
      .me()
      .then(response => {
        const currentUser: CurrentUser = response

        setCurrentUser(currentUser)

        if (currentUser.email_confirmed_at) {
          this.navigateToOnboarding()
        } else {
          Notification.notifyError(t('ConfirmEmail::Account verification required'))
        }
      })
      .catch(console.error)
  }

  onResendEmailClick(e) {
    const { t } = this.props
    e.preventDefault()

    OnboardingController
      .resendConfirmationEmail()
      .then(response => {
        if (response.success) {
          Notification.notifySuccess(t('ConfirmEmail::Activation email send'))
        }
      })
      .catch(console.error)
  }

  onLogoutClick(e) {
    e.preventDefault()

    SessionController
      .logout()
      .then(() => {
        window.location.assign('/')
      })
      .catch(console.error)
  }

  render() {
    const { currentUser, t } = this.props
    return (
      <div className="flex min-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto bg-background p-4 font-sans! md:p-8">
        <Helmet>
          <title>{t('ConfirmEmail::{{__appName}} | Confirm email')}</title>
        </Helmet>
        <ScrollToTopOnMount />

        <div className="flex w-full max-w-md flex-col items-center gap-8 py-8">
          <a href="/">
            <img src={Images.LOGO_TEXT} className="h-8 w-auto" />
          </a>

          <div className="flex w-full flex-col items-center gap-6 rounded-2xl border border-border bg-card p-8 text-center md:p-10">
            <span className="flex size-14 items-center justify-center rounded-full bg-muted/40 text-foreground">
              <MailCheck className="size-6" />
            </span>

            <div>
              <h1 className="text-2xl font-bold! tracking-tight text-foreground">
                {t('ConfirmEmail::Activation e-mail send')}
              </h1>
              <p
                className="mt-3 text-sm text-muted-foreground md:text-base"
                dangerouslySetInnerHTML={{
                  __html: t('ConfirmEmail::We\'ve sent an activation link to <b>{{email}}</b>. Open it, then confirm below.', { email: currentUser.email }),
                }}
              />
            </div>

            <Button size="lg" className="w-full" onClick={this.onVerifyConfirmedClick}>
              {t('ConfirmEmail::I\'ve verified my account')}
            </Button>

            <div className="flex items-center gap-4">
              <Button variant="link" onClick={this.onResendEmailClick}>
                {t('ConfirmEmail::Send again')}
              </Button>
              <Button variant="link" onClick={this.onLogoutClick}>
                {t('ConfirmEmail::Logout')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const { authentication: { currentUser } } = state

  return {
    currentUser: currentUser,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {
    setCurrentUser: (user: CurrentUser) => dispatch(setCurrentUser(user)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmEmail))
